import { render, staticRenderFns } from "./UptimeKuma.vue?vue&type=template&id=8882df80&scoped=true"
import script from "./UptimeKuma.vue?vue&type=script&lang=js"
export * from "./UptimeKuma.vue?vue&type=script&lang=js"
import style0 from "./UptimeKuma.vue?vue&type=style&index=0&id=8882df80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8882df80",
  null
  
)

export default component.exports